import Head from 'next/head'
import { useRouter } from 'next/router'

const SearchEngineMetaTags = () => {
  const { pathname } = useRouter()

  const isMainPage = pathname === '/'
  const isAuthPage = pathname === '/auth/signin'
  const isClubPage = pathname === '/app/club'

  const shouldPageBeIndexed =
    process.env.NEXT_PUBLIC_ENVIRONMENT === 'prod' &&
    (isMainPage || isAuthPage || isClubPage)

  return shouldPageBeIndexed ? (
    <Head>
      {/* Лендинг клаба задаёт свои description и OG-теги в ClubRootPage. */}
      {!isClubPage && (
        <>
          <meta
            name="description"
            content="Личный кабинет собственника Sminex"
          />
          <meta
            name="keywords"
            content="Sminex, смайнекс, смайнэкс, сминекс, личный кабинет собственника, передать показания счетчиков, оплатить счет ЖКУ коммуналку"
          />
        </>
      )}
      {isMainPage && (
        <>
          <meta
            name="google-site-verification"
            content="PE2AQA3TyvLxEKEH4LqYAW3zLGPEETdsthHkBOanygQ"
          />
          <meta name="yandex-verification" content="f3cbf20c5740eb6b" />
        </>
      )}
      {isAuthPage && <link rel="canonical" href="https://comfort.sminex.com" />}
    </Head>
  ) : (
    <Head>
      <meta name="robots" content="noindex" />
      <meta name="googlebot" content="noindex" />
    </Head>
  )
}

export default SearchEngineMetaTags
